// quiz.js
(function() {
  // Add all required styles
  const styles = `
    .button--quiz {
      position: relative;
      opacity: 0;
      transform: translateY(10px);
      animation: fadeInUp 0.6s ease-out forwards;
      animation-delay: 0.3s;
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

  /* Update the modal styles for desktop animation */
  .quiz-modal {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 400px;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    z-index: 99999;
    transform: translateY(40px); /* Start from 40px down */
    opacity: 0; /* Start transparent */
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  }

    .quiz-header {
      padding: 1.5rem;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .quiz-header h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }

    .quiz-close {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0.5rem;
      color: #252525;
    }

    .quiz-content {
      padding: 2rem;
    }

    .quiz-question {
      margin: 0 0 1.5rem;
      font-size: 14px;
      font-weight: 500;
      color: #252525;
    }

    .quiz-option {
      width: 100%;
      padding: 1rem;
      margin-bottom: 0.75rem;
      text-align: left;
      background: none;
      border: 1px solid #E5E5E5;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s ease-in-out;
      border-radius: 4px;
    }

    .quiz-option:hover {
      background: #F7F7F7;
    }

    .quiz-size-input {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      margin: 2rem 0;
    }

    .quiz-size-btn {
      background: none;
      border: 1px solid #E5E5E5;
      width: 40px;
      height: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      border-radius: 4px;
    }

    .quiz-size-btn:hover {
      background: #F7F7F7;
    }

    .quiz-size-number {
      width: 80px;
      height: 40px;
      text-align: center;
      border: 1px solid #E5E5E5;
      font-size: 16px;
      -moz-appearance: textfield;
      border-radius: 4px;
    }

    .quiz-size-number::-webkit-outer-spin-button,
    .quiz-size-number::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .quiz-result {
      text-align: center;
    }

    .quiz-result h4 {
      margin: 0 0 0.5rem;
      font-size: 18px;
    }

    .quiz-result-product {
      margin: 2rem 0;
      padding: 2rem;
      background: #F7F7F7;
      border-radius: 4px;
    }

    .quiz-result-product h5 {
      margin: 0 0 0.5rem;
      font-size: 16px;
      font-weight: 500;
    }

    .quiz-submit {
      width: 100%;
      background-color: #252525;
      color: #FFFFFF;
      border: none;
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;
      text-decoration: none;
      display: inline-block;
      text-align: center;
      border-radius: 0px;
    }

    .quiz-progress {
      padding: 1rem 2rem;
      border-top: 1px solid #E5E5E5;
    }

    .quiz-progress-bar {
      width: 100%;
      height: 2px;
      background: #E5E5E5;
    }

    .quiz-progress-indicator {
      height: 100%;
      background: #252525;
      transition: width 0.3s ease-in-out;
    }

    .quiz-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99998;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .quiz-modal.is-active {
    transform: translateY(0); /* Move to normal position */
    opacity: 1; /* Fade in */
  }

  @media (max-width: 768px) {
      .quiz-modal {
        width: 100%;
        right: 0;
        bottom: 0;
        border-radius: 12px 12px 0 0;
        transform: translateY(100%);
        max-height: 90vh;
        overflow-y: auto;
      }

      .quiz-modal.is-active {
        transform: translateY(0);
      }
    
    .quiz-content {
      padding: 1.5rem;
    }
    
    .quiz-size-input {
      gap: 0.75rem;
    }
    
    .quiz-size-btn {
      width: 36px;
      height: 36px;
    }
  }`;

  // Add the styles to the document
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);

  class FitQuiz {
    constructor() {
      this.step = 0;
      this.answers = {
        activity: null,
        chafing: null,
        waistSize: 29
      };
      this.isOpen = false;
      this.init();
    }

    init() {
      console.log('Quiz initializing');
      this.insertQuizButton();
      this.addFindYourSizeButton();
    
      // Add a CSS rule for the recommended size styling
      const style = document.createElement('style');
      style.textContent = `
        .block-swatch--recommended {
          padding: 2px;
          border-radius: 1px;
        }
        .block-swatch--recommended label {
          margin: 0 !important;
        }
        .size-recommendation {
          background: #ededed;
          padding: 12px 15px;
          margin-top: 15px;
          font-size: 14px;
          display: block;
        }
        .size-recommendation strong {
          font-weight: 500;
        }

      `;
      document.head.appendChild(style);
      
      // Listen for product:updated events to reapply on toggle
      document.addEventListener('product:updated', () => {
        setTimeout(() => {
          this.addFindYourSizeButton();
          this.applySizeRecommendation();
        }, 500);
      });
    }

    insertQuizButton() {
      // Find the first button in the hero section
      const primaryButton = document.querySelector('.slideshow__slide .button--primary');
      if (primaryButton) {
        const buttonWrapper = primaryButton.closest('.button-wrapper, .button-group__wrapper');
        
        if (buttonWrapper) {
          // If it's not already a button group, convert it to one
          if (buttonWrapper.classList.contains('button-wrapper')) {
            const newButtonGroup = document.createElement('div');
            newButtonGroup.className = 'button-group';
            newButtonGroup.innerHTML = '<div class="button-group__wrapper"></div>';
            buttonWrapper.parentNode.replaceChild(newButtonGroup, buttonWrapper);
            newButtonGroup.querySelector('.button-group__wrapper').appendChild(primaryButton);
            
            // Add our new quiz button
            const quizButton = document.createElement('button');
            quizButton.className = 'button button--secondary button--quiz';
            quizButton.textContent = 'Find Your Perfect Pair';
            quizButton.addEventListener('click', () => this.openQuiz());
            newButtonGroup.querySelector('.button-group__wrapper').appendChild(quizButton);
          } else {
            // It's already a button group, just add our button
            const quizButton = document.createElement('button');
            quizButton.className = 'button button--secondary button--quiz';
            quizButton.textContent = 'Find Your Perfect Pair';
            quizButton.addEventListener('click', () => this.openQuiz());
            buttonWrapper.appendChild(quizButton);
          }
        }
      }
    }


addFindYourSizeButton() {
  // Skip completely on product pages since button is hardcoded
  if (window.location.pathname.includes('/products/')) {
    return;
  }
  
  // Rest of the existing code to add buttons on other pages...
}

    createQuizModal() {
      const modal = document.createElement('div');
      modal.className = 'quiz-modal';
      modal.innerHTML = `
        <div class="quiz-header">
          <h3 class="heading h4">Find your perfect pair</h3>
          <button class="quiz-close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          
        </div>
        <div class="quiz-content">
          ${this.getStepContent()}
        </div>
        <div class="quiz-progress">
          <div class="quiz-progress-bar">
            <div class="quiz-progress-indicator" style="width: ${(this.step / 3) * 100}%"></div>
          </div>
        </div>
      `;

      modal.querySelector('.quiz-close').addEventListener('click', () => this.closeQuiz());
      this.attachStepListeners(modal);

      return modal;
    }

    getStepContent() {
      switch(this.step) {
        case 0:
          return `
            <div>
              <p class="quiz-question">Are you typically active or sedentary during the day?</p>
              <button class="quiz-option" data-value="active">Active</button>
              <button class="quiz-option" data-value="sedentary">Sedentary</button>
            </div>
          `;
        case 1:
          return `
            <div>
              <p class="quiz-question">Do you experience chafing?</p>
              <button class="quiz-option" data-value="yes">Yes</button>
              <button class="quiz-option" data-value="no">No</button>
            </div>
          `;
        case 2:
          return `
            <div>
              <p class="quiz-question">What is your pants size?</p>
              <div class="quiz-size-input">
                <button class="quiz-size-btn minus" type="button">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
                <input type="number" min="29" max="47" value="${this.answers.waistSize}" class="quiz-size-number">
                <button class="quiz-size-btn plus" type="button">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
              <button class="quiz-submit button button--secondary">See Results</button>
            </div>
          `;
        case 3:
          const recommendation = this.calculateRecommendation();
          return `
            <div class="quiz-result">
              <h4>Your Perfect Pair</h4>
              <p>Based on your answers, we recommend:</p>
              <div class="quiz-result-product">
                <h5>${recommendation.productType === 'boxer-briefs' ? 'Boxer Briefs' : 'Trunks'}</h5>
                <p>Size: ${recommendation.size}</p>
              </div>
              <a href="/products/${recommendation.productType}" class="quiz-submit button button--secondary">Shop Now</a>
            </div>
          `;
        default:
          return '';
      }
    }

    attachStepListeners(modal) {
      const content = modal.querySelector('.quiz-content');
      
      if (this.step === 0 || this.step === 1) {
        content.querySelectorAll('.quiz-option').forEach(button => {
          button.addEventListener('click', (e) => {
            const value = e.target.dataset.value;
            if (this.step === 0) {
              this.answers.activity = value;
              this.trackEvent('quiz_activity', value);
            } else {
              this.answers.chafing = value;
              this.trackEvent('quiz_chafing', value);
            }
            this.nextStep();
          });
        });
      } else if (this.step === 2) {
        const input = content.querySelector('.quiz-size-number');
        const minusBtn = content.querySelector('.quiz-size-btn.minus');
        const plusBtn = content.querySelector('.quiz-size-btn.plus');
        
        const updateSize = (value) => {
          value = Math.min(47, Math.max(29, value));
          this.answers.waistSize = value;
          input.value = value;
        };
        
        input.addEventListener('change', (e) => {
          updateSize(parseInt(e.target.value) || 29);
        });
        
        minusBtn.addEventListener('click', () => {
          updateSize(parseInt(input.value) - 1);
        });
        
        plusBtn.addEventListener('click', () => {
          updateSize(parseInt(input.value) + 1);
        });

        content.querySelector('.quiz-submit').addEventListener('click', () => {
          this.complete();
        });
      }
    }

    calculateRecommendation() {
      const { activity, chafing, waistSize } = this.answers;
      
      let productType = 'trunks';
      if (activity === 'active' || chafing === 'yes') {
        productType = 'boxer-briefs';
      }
      
      let size = 'S';
      if (waistSize >= 31 && waistSize <= 34) size = 'M';
      else if (waistSize >= 35 && waistSize <= 38) size = 'L';
      else if (waistSize >= 39 && waistSize <= 43) size = 'XL';
      else if (waistSize >= 44) size = 'XXL';
      
      return { productType, size };
    }

    nextStep() {
      this.step++;
      this.updateQuiz();
    }

    complete() {
      const recommendation = this.calculateRecommendation();
      localStorage.setItem('underwearFitRecommendation', JSON.stringify(recommendation));
      sessionStorage.setItem('justCompletedQuiz', 'true');

      this.trackEvent('quiz_complete', `${recommendation.productType}:${recommendation.size}`);

      this.step = 3;
      this.updateQuiz();

      content.querySelector('.quiz-submit').addEventListener('click', () => {
        this.trackEvent('quiz_shop_now', this.calculateRecommendation().productType);
      });
    }

    updateQuiz() {
      const oldModal = document.querySelector('.quiz-modal');
      const newModal = this.createQuizModal();
      
      // Preserve the is-active class if it exists
      if (oldModal.classList.contains('is-active')) {
        newModal.classList.add('is-active');
      }
      
      oldModal.parentNode.replaceChild(newModal, oldModal);
    }

    openQuiz() {
      // If modal already exists, don't create a new one
      const existingModal = document.querySelector('.quiz-modal');
      if (existingModal) {
        return;
      }
      
      // Create overlay for outside clicks
      const overlay = document.createElement('div');
      overlay.className = 'quiz-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99998;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      
      // Handle clicking outside to close
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          this.closeQuiz();
        }
      });
      
      document.body.appendChild(overlay);
      
      // Create and add the modal
      const modal = this.createQuizModal();
      document.body.appendChild(modal);
      
      // Trigger animations with a slight delay
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
          modal.classList.add('is-active');
        });
      });
      
      this.isOpen = true;
      this.trackEvent('quiz_open', 'Quiz opened');
    }
    
    // Update the closeQuiz method
    closeQuiz() {
      const modal = document.querySelector('.quiz-modal');
      const overlay = document.querySelector('.quiz-overlay');
      
      if (modal) {
        modal.classList.remove('is-active');
        
        if (overlay) {
          overlay.style.opacity = '0';
        }
        
        // Wait for animations to complete before removing
        setTimeout(() => {
          if (modal && modal.parentNode) {
            modal.remove();
          }
          if (overlay && overlay.parentNode) {
            overlay.remove();
          }
        }, 400); // Match this with your transition duration
      }
      
      this.isOpen = false;
      if (this.step < 3) {
        this.trackEvent('quiz_abandoned', `Step ${this.step + 1}`);
      }
    }

      // Add this method to handle size recommendations
  applySizeRecommendation() {
    console.log('Applying size recommendation');
    const recommendation = localStorage.getItem('underwearFitRecommendation');
    if (!recommendation) {
      return;
    }
    
    try {
      const { size } = JSON.parse(recommendation);
      console.log('Found recommended size:', size);
      
      // Add recommended border
      const sizeButtons = document.querySelectorAll('.block-swatch');
      let recommendedFound = false;
      
      sizeButtons.forEach(swatch => {
        const input = swatch.querySelector('input[type="radio"]');
        if (input && input.value === size) {
          swatch.classList.add('block-swatch--recommended');
          recommendedFound = true;
        }
      });
      
      // Add text below size selector
      if (recommendedFound) {
        this.trackEvent('recommendation_shown', size);
        const sizeList = document.querySelector('.block-swatch-list');
        if (sizeList) {
          // Remove any existing
          const existingRec = document.querySelector('.size-recommendation');
          if (existingRec) {
            existingRec.remove();
          }
          
          const sizeText = {
            'S': 'Small (28-30")',
            'M': 'Medium (31-34")',
            'L': 'Large (35-38")',
            'XL': 'Extra Large (39-43")',
            'XXL': 'Double Extra Large (44-47")'
          }[size] || size;
          
          const recommendationDiv = document.createElement('div');
          recommendationDiv.className = 'size-recommendation';
          recommendationDiv.innerHTML = `Your recommended size is: <strong>${sizeText}</strong>`;
          
          sizeList.insertAdjacentElement('afterend', recommendationDiv);
          console.log('Added size recommendation text');
        }
      }
    } catch (error) {
      console.error('Error applying size recommendation:', error);
    }
  }

    trackEvent(action, label = null, value = null) {
  // Google Analytics tracking
  if (typeof gtag === 'function') {
    gtag('event', action, {
      'event_category': 'Size Quiz',
      'event_label': label,
      'value': value
    });
    console.log(`Tracked event: ${action}`, label, value);
  }
    }

    
  }

  // Initialize the quiz when DOM is ready
  function initQuiz() {
    console.log('Initializing quiz');
    window.fitQuiz = new FitQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();